module.exports = __webpack_public_path__ + "static/media/theme.a6655a39.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/media/theme.mp3
// module id = 48
// module chunks = 0